import render  from "./render-mustache";
import ToastComponent from './ToastComponent.js';
import { findMatchingPropertyName } from '../my_simple_functions.js';

const highlightLocation = (location, placeName, by) => {
    // The functions highlights the matching location
    const loc_highlight = {
        wellknown_name: location.wellknown_name,
        block: location.block,
        township: location.township,
        city: location.city,
        province: location.province
    }

    if (by === 'ALL') {
        const prop = findMatchingPropertyName(loc_highlight, placeName)
        loc_highlight[prop] = `<span class="text-primary" style="text-decoration: underline">${loc_highlight[prop]}</span>`;
    } else if (by === 'province') loc_highlight.province = `<span class="text-primary" style="text-decoration: underline">${loc_highlight.province}</span>`;
    else if (by === 'city') loc_highlight.city = `<span class="text-primary" style="text-decoration: underline">${loc_highlight.city}</span>`;
    else if (by === 'township') loc_highlight.township = `<span class="text-primary" style="text-decoration: underline">${loc_highlight.township}</span>`;
    else if (by === 'block') loc_highlight.block = `<span class="text-primary" style="text-decoration: underline">${loc_highlight.block}</span>`;
    else if (by === 'wellknown_name') loc_highlight.wellknown_name = `<span class="text-primary" style="text-decoration: underline">${loc_highlight.wellknown_name}</span>`;
    return loc_highlight;
}

export const Businesses = (container, props) => {
    // If there are businesses in the list but no search request made
    if (props.findBranchesInLocations === undefined) {props.businesses.forEach(business => {
            business.location = highlightLocation(business.location, props.searchData.placeName, props.searchData.by);
        });
    }else {
        // If list of businesses in the array is empty and the is no search made - Default Requet or Display
        if (props.searchData.placeName === '') {
            const buzz = Array.from(props.findBranchesInLocations(4, 'Gauteng', 'province'));  
            buzz.forEach(business => {
                business.location = highlightLocation(business.location, 14, 'province');
                props.businesses.push(business);
            });
        } else { // If search requet is made
            const buzz = Array.from(props.findBranchesInLocations(props.searchData.place_id, props.searchData.placeName, props.searchData.by));
            if (!buzz || !buzz.length) {
                ToastComponent(container, { message: "No Food Zone found around!!" });
                return;
            } else {
                // Empty the array without losing its memory location
                for (let i = 0; i < props.businesses.length; i++) props.businesses[i] = undefined;
                props.businesses.length = 0;

                // Then for each push to businesses 
                buzz.forEach(business => {
                    business.location = highlightLocation(business.location, props.searchData.placeName, props.searchData.by);
                    props.businesses.push(business);
                });
            }
        }
    }
    
// Function to generate a random number between 1 and 10, optionally ensuring it's different from a given number
const randomNumber = (number = null) => {
    let random = Math.floor(Math.random() * 10) + 1;
    while (number !== null && random === number) {
        random = Math.floor(Math.random() * 10) + 1;
    }
    return random;
}


    const template = `
        <div class="row mb-2">
            {{#businesses}}
                <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                    <div class="card shadow d-flex flex-column h-100">
                        <div id="carouselIndicators{{branch_id}}" class="carousel slide" data-ride="carousel">
                            <div class="carousel-inner">
                                <div class="carousel-item">
                                    <img class="d-block w-100" src="{{slide1}}" alt="First slide" style="object-fit: cover; height: 10rem;">
                                </div>
                                <div class="carousel-item active">
                                    <img class="d-block w-100" src="{{slide2}}" alt="Second slide" style="object-fit: cover; height: 10rem;">
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#carouselIndicators{{branch_id}}" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#carouselIndicators{{branch_id}}" role="button" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a>
                        </div>
                        <div class="card-body py-1">
                            <h5 class="card-title mb-1">{{name}}{{#alias}} ({{alias}}){{/alias}}</h5>
                        </div>
                        {{#slogan}}<div class="ml-4 text-muted"><small>{{slogan}}</small></div>{{/slogan}}
                        <hr class="my-1">
                        <div class="mx-4 mb-2 flex-grow-1">We sell <span><b>{{food_type}}</b></span></div>
                        <ul>
                            {{#dishes}}
                                <li><small>{{item_name}} - 
                                        <span class="text-danger">
                                            <b>R{{#branch_price}}{{branch_price}}{{/branch_price}}{{^branch_price}}{{price}}{{/branch_price}}</b>
                                        </span>
                                    </small>
                                </li>
                            {{/dishes}}
                        </ul>
                        <a class="btn-view-more btn btn-outline-success btn-sm" href="#/menu/{{branch_id}}">View More on The Menu</a>
                        <div class="card-footer">
                            {{#location}}
                                <small class="text-muted font-weight-light">We are located @: {{{block}}}, {{{township}}}, {{{city}}}, {{{province}}}</small>
                                </br>
                                {{#wellknown_name}}<small class="text-muted font-weight-light">When nearby, ask about: {{{wellknown_name}}}</small>{{/wellknown_name}}
                            {{/location}}
                        </div>
                    </div>
                </div>
            {{/businesses}}
        </div>
    `;
    props.businesses.forEach(x => {
        x.slide1 = `./${randomNumber()}.jpg`;
        x.slide2 = `./${randomNumber(x.slide1)}.jpg`;
    });
    render(container, 'innerHTML', template, { businesses: props.businesses});
}

export default Businesses;